module.exports = __webpack_public_path__ + "static/fipcbluefloralmain-12d1f93417853a98d5bd5dc2ba46fbc5.jpeg";